import BugReportIcon from '@mui/icons-material/BugReport';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';

interface WidgetHeaderProps {
  onClose: () => void;
  disabled?: boolean;
}

export const WidgetHeader: React.FC<WidgetHeaderProps> = ({ onClose, disabled }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1.5,
        borderBottom: '1px solid #e5e7eb',
        backgroundColor: '#f8fafc',
      }}
    >
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: '8px',
          backgroundColor: '#EFFFF3',
          color: '#0F9A00',
          display: 'grid',
          placeItems: 'center',
        }}
      >
        <BugReportIcon sx={{ fontSize: 18 }} />
      </Box>
      <Typography id="qa-panel-title" variant="subtitle2" sx={{ fontWeight: 600, fontSize: '0.9rem' }}>
        Report a Bug
      </Typography>
      <IconButton size="small" onClick={onClose} disabled={disabled} sx={{ ml: 'auto', p: 0.5, color: '#6b7280' }}>
        <CloseIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Box>
  );
};
